import {CSVUpload} from "@/components/panel/csv-upload";
import {HelpSupport} from "@/components/panel/help-support";
import {useAppSelector} from "@/hooks/reducer-hooks";

export default function Panel() {
    const user = useAppSelector((state) => state.user)

    // Reducer getter + setter
    // const subscriptionPromotions = getSubscriptionPromotions()

    if (!user || !user.subscriptionPromotions) {
        return <p>Loading...</p>;
    }

    return (
        <main className="container mx-auto p-4">
            <div className="space-y-8">
                <CSVUpload/>
                <HelpSupport/>
            </div>
        </main>
    );
}
